export class SystemMonitoringController {

	constructor($scope, MonitorDao, DatabaseSyncDao, JFrogEventBus, JFrogGridFactory, uiGridConstants, JFrogModal,$rootScope) {
		this.MonitorDao = MonitorDao;
		this.DatabaseSyncDao = DatabaseSyncDao;
		this.modal = JFrogModal;
		$rootScope.h1Header='Xray System Monitoring';
		this.JFrogGridFactory = JFrogGridFactory;
		this.uiGridConstants = uiGridConstants;
		let EVENTS = JFrogEventBus.getEventsDefinition();
		let removeListener = JFrogEventBus.register(EVENTS.MONITORING_DATA_UPDATED, (msg) => this.wsDataRecieved(msg));
		this.getUpdateData();
		this.$scope = $scope;
		this._createGrid();
		$scope.$on('$destroy', () => {
            $rootScope.h1Heade='';
			removeListener();
		});
	}

	_transformGridData() {

		_.each(this.gridData, (mainObjVal, key) => {
			mainObjVal.servicesLength = mainObjVal.services.length;
			mainObjVal.uniqueServices = this._getUniqueServices(mainObjVal.services);
			mainObjVal.servicesObj = this._getServicesIobj(mainObjVal.services);

		});
	}

	_getUniqueServices(servicesArr = []) {

		let arr = _.map(servicesArr, (n) => {
			return n.split('@')[0];
		});
		return _.uniq(arr);
	}

	_getServicesIobj(servicesArr = []) {

		let arr = _.map(servicesArr, (n) => {
			let tmpObj = {};
			tmpObj.type = n.split('@')[0];
			tmpObj.id = n.split('@')[1];

			return tmpObj;
		});
		return arr;
	}

	getUpdateData(showSpinner = true, callListener = true) {
		this.MonitorDao.getIssues({$no_spinner: true}).$promise.then((data) => {
			this.gridData = data.problems;
			if (this.gridData) {
				this.showMonitoring = true;
			} else {
				this.showMonitoring = false;
			}

			this._transformGridData();

			this.gridOptions.setGridData(this.gridData);

			if (data.problems) {
				if (data.problems.length < 1) {
					this.noData = true;
					this.severity_level = 'icon-xray-monitoring-ready';
				} else {
					this.noData = false;

				}

			}

		});


	}


	_createGrid() {
		this.gridOptions = this.JFrogGridFactory.getGridInstance(this.$scope)
		                       .setRowTemplate('default')
		                       .setColumns(this._getColumns());
		/*
		 .setButtons(this._getActions())
		 */

		this.gridOptions.setGridData([]);

	}


	_getColumns() {
		return [


			{
				name: 'Severity',
				displayName: 'Severity',
				cellTemplate: `<div ng-class="[row.entity.severity]" class="severity ui-grid-cell-contents"> <i ng-class="{'icon-notif-warning':row.entity.severity=='warning','icon-notif-error':row.entity.severity=='error'}" class="monitoring-severity icon icon-notif-warning"></i> {{row.entity.severity| capitalizeFirst }}</div>`,
				field: 'severity',
				width: '13%'
			},
			{
				name: 'Problem',
				displayName: 'Problem',
				field: 'problem',
				width: '72%'
			},
			{
				name: 'Services',
				displayName: 'Services',
				cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.servicesLength}} | {{row.entity.uniqueServices.join(', ') | capitalizeFirst }}<a ng-click="grid.appScope.SystemMonitoring.showServicesModal(row.entity);"> (Show All)</a></div>`,
				field: 'services',
				width: '15%'
			}
		];
	}

	wsDataRecieved(msg) {
		this.gridData = msg.Data.problems;
		this._transformGridData();
		this.gridOptions.setGridData(this.gridData);

		if (msg.Data.problems.length < 1) {
			this.noData = true;
			this.severity_level = 'icon-xray-monitoring-ready';
		} else {
			this.noData = false;

		}

		this.$scope.$apply();
	}

	showServicesModal(row) {
		//show_list_grid_modal.html

		let modalScope = this.$scope.$new();

		this.listGridOptions = this.JFrogGridFactory.getGridInstance(this.$scope)
		                           .setRowTemplate('default')
		                           .setColumns(this._getListColumns())
		                           .setRowsPerPage(8)
		                           .setGridData(row.servicesObj);
		modalScope.modalTitle = ' Monitoring Issue ';
		modalScope.errorMessage = row.problem;
		modalScope.severity = row.severity;
		modalScope.gridOptions = this.listGridOptions;
		this.modal.launchModalWithTemplateMarkup(require('../../../../modal_templates/show_list_new_grid_modal.html'), modalScope).result.then(() => {
		});

		//console.log('need to show modal for the following row : ', row);
	}

	_getListColumns() {
		return [
			{
				displayName: 'Service Type',
				field: 'name',
				cellTemplate: `<div class="ui-grid-cell-contents" >{{row.entity.type | capitalizeFirst}}</div>`,
				width: '50%'
			},
			{

				displayName: 'Service Id',
				cellTemplate: `<div class="ui-grid-cell-contents" >{{row.entity.id}}</div>`,
				field: 'name',
				width: '50%'
			}
		];
	}
}



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/system_monitoring/system_monitoring.controller.js